import { render } from "./ConversationsThreadBaseLayout.vue?vue&type=template&id=57a4dd0c"
import script from "./ConversationsThreadBaseLayout.vue?vue&type=script&lang=js"
export * from "./ConversationsThreadBaseLayout.vue?vue&type=script&lang=js"
script.render = render

export default script